module.exports = __webpack_public_path__ + "assets/img/100904.e4fb2309.png";